var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-filter',{attrs:{"value":_vm.options.value,"label":_vm.displayLabel,"showLabel":false,"url":_vm.getUrl,"multiselect":_vm.options.multiselect,"required":_vm.options.required,"hasError":_vm.hasError},on:{"input":_vm.handleValueChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }